import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { activityService } from '../../services/activityService';

export const useGetActivityTypes = params => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.activity.activity_types, params],
    queryFn: () =>
      activityService.activityTypes(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
